import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'
import { draftOrderPartial } from './partials'

const draftOrderCreateMutation = `
  mutation ShopifyDraftOrderCreate(
    $customerId: ID,
    $lineItems: [DraftOrderLineItemInput!]
  ) {
    draftOrderCreate(input: {
      customerId: $customerId,
      lineItems: $lineItems
    }) {
      userErrors {
        message
        field
      }

      draftOrder {
        ${draftOrderPartial}
      }
    }
  }
`

const doDraftOrderCreate = (integrationId, customerId, data) => dispatch => {
  const variables = { customerId, ...data }

  return dispatch(
    doGraphqlRequest(
      types.DRAFT_ORDER_CREATE_REQUEST,
      draftOrderCreateMutation,
      variables,
      {
        graphqlFunc: graphql(integrationId),
      }
    )
  )
}

export default doDraftOrderCreate
